<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="teal" class="white--text" :disabled="!selectedUsers.length" @click="exportToXls">
                            {{ $t('exportXLS') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <div class="py-3"></div>
                <users-filters :users-type="$store.state.clients.types.seller"
                    @filter-change="filterChange"></users-filters>
                <div class="py-3"></div>
                <v-card>
                    <sellers-table :filters="filters" @load-error="onDataLoadError"></sellers-table>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { UsersService } from '../../../services';
import UsersFilters from '../../../components/filters/UsersFilters';
import { SellersTable } from "../../../components/data-tables"
import { MixinTableLoadSnack } from '../../../mixins';

export default {
    name: "Sellers",
    data() {
        return {
            metaUrl: '/users/sellers',
            filters: {}
        }
    },
        components: { UsersFilters, SellersTable },
    mixins: [MixinTableLoadSnack],
    computed: {
        ...mapState(['selectedUsers']),
    },
    methods: {
        filterChange(filters) {
            this.filters = filters;
        },
        exportToXls() {
            UsersService.buyersExport(this.selectedUsers.map(item => item.id));
            this.$store.commit('setSelectedUsers', []);
        },
    },
    beforeDestroy() {
        this.$store.commit('setSelectedUsers', []);
    }
}
</script>

<style scoped></style>
